import React from 'react';
import PropTypes from 'prop-types';
import AppSelect from '../../../../../../common/AppSelect';
import Message from '../../../../../../common/Message';
import {
  cancelPurchaseMapper,
  OPTIONS,
} from '../../../../../../../helpers/tickets/CancelPurchaseHelper';
import { useCancelPurchaseFormStyles } from './styles';

const CancelPurchaseForm = ({ ...props }) => {
  const { stateData, onPayment, paymentData } = props;
  const classes = useCancelPurchaseFormStyles();

  const handleChangePaymentMethod = (e) => {
    onPayment(e.target);
  };

  return (
    <React.Fragment>
      <AppSelect
        label="Medio de pago"
        name="paymentMethod"
        options={OPTIONS}
        onChange={handleChangePaymentMethod}
        required
        success={stateData?.paymentMethod?.success || false}
        error={stateData?.paymentMethod?.error || false}
        onClick={() => {}}
        onBlur={() => {}}
      />
      {paymentData !== '' && (
        <div className={classes.message}>
          <Message
            message={cancelPurchaseMapper.get(paymentData)}
            fullRounded
            severity={paymentData === 2 ? 'alert' : 'info'}
          />
        </div>
      )}
    </React.Fragment>
  );
};

CancelPurchaseForm.propTypes = {
  onPayment: PropTypes.func,
  stateData: PropTypes.object,
  paymentData: PropTypes.number,
};

export default CancelPurchaseForm;
